// import React from 'react';
// import Form from 'react-bootstrap/Form';

// type FormCheckProps = {
//   type: string;
//   label: string;
// };

// const CustomFormCheck: React.FC<FormCheckProps> = ({ type, label,onChange,checked }) => (
//  <div className='container' >
//  <Form.Check
//     type={type}
//     id={type}
//     label={label}
//     onChange={onChange}
//     checked={checked}
//     className="form-check-inline" 
//   />
//  </div>
 
// );

// export default CustomFormCheck;


import React from "react";
import Form from "react-bootstrap/Form";
import checkBox from "../../css/CustomFormCheck.css";


const CustomFormCheck = ({ type, label, onChange, checked }) => {
  return (
    <div className="custom-form-check">
      <Form.Check
        type={type}
        id={label.replace(/\s+/g, "-").toLowerCase()} // Generates unique ID
        label={label}
        onChange={onChange}
        checked={checked}
        className={checkBox.CustomFormCheck}
      />
    </div>
  );
};

export default CustomFormCheck;
